import { render, staticRenderFns } from "./opsum.vue?vue&type=template&id=c1b3b072&scoped=true"
import script from "./opsum.vue?vue&type=script&lang=js"
export * from "./opsum.vue?vue&type=script&lang=js"
import style0 from "./opsum.vue?vue&type=style&index=0&id=c1b3b072&prod&scoped=true&lang=css"
import style1 from "./opsum.vue?vue&type=style&index=1&id=c1b3b072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b3b072",
  null
  
)

export default component.exports